import { createRouter, createWebHistory } from "vue-router";
import home from "../components/home.vue";
import editor from "../components/editor.vue";
import examples from "../components/examples.vue";
import api from "../components/api.vue"

const routes = [{
        path: '/',
        name: '首页',
        component: home
    },
    {
        path: '/examples',
        name: '示例',
        component: examples
    },
    {
        path: '/editor',
        name: '编辑',
        component: editor
    },
    {
        path: '/api',
        name: 'API',
        component: api
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;